import type { FaireProductEntity } from "../../entity_types/product";

export const p_8hyt7q29tq: FaireProductEntity = {
  token: "p_8hyt7q29tq",
  type: "product",
  name: "6.5' Handmade damascus folding knife, Pocket Knife",
  brandToken: "b_qbp756w3aa",
  brandName: "FH KNIVES",
  imageUrl:
    "https://cdn.faire.com/fastly/48967950d8dac45b51c2b37a258c42d616efe93a6ca388395cdcf9ab7c666ca6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d2d7fc5d27471cd3692f9c6e0e4ffed9c358d6424ba1df93c8f298951b47f158.png",
    "https://cdn.faire.com/fastly/a07dd5a83bf1eb8b4b3d0ec61b09cc844f376fc7c7691e2beaf723b7892b34f0.jpeg",
    "https://cdn.faire.com/fastly/23018f089998d51b3997e12cb1dbd5a2afa7310a55d6ef9ef85777e800338975.png",
    "https://cdn.faire.com/fastly/98c24cdd271761bb573b937932a04c2701dab7354de94203409c16a486a47d1b.png",
    "https://cdn.faire.com/fastly/83f8eee4959348a28ad10c33faa5f7538d366a2d5516e1cc1fc290b37555519b.png",
    "https://cdn.faire.com/fastly/68f21a1868ce1ba023d95efbf7d63a2fd8f90e0197dcbd0a2dd4995cb4f71008.jpeg",
    "https://cdn.faire.com/fastly/0ada943b5fc99dabba71ec7204f1271e991aad9f29a9a1613b1962138499dd11.jpeg",
    "https://cdn.faire.com/fastly/f38b562483d0b80896dac2bf7e75c40845696a8e9b1d4ed0b446575b1ea5ce0d.jpeg",
  ],
  priceDollars: 26.99,
  description:
    "【Solid, sharp & appealing】- Truly hammer forged damascus knife; composed of 1080 and 15N20, folded 5 times, starting from 9-layers into a twist pattern of 300 layers of damascus steel. Shatter proof to withstand any cutting task.\n\n【Masterpiece gift】- Our Damascus knives make the perfect gift for him—ideal gift for groomsmen, best man, father, boyfriend, and husband. A timeless and premium choice!\n\n【Looks classy, works sharply】- This damascus steel folding knife gone through high temperatures and excellent edge retention treatment, in its making, for improved longevity. Sharp & large enough for high performance work without causing hand fatigue.",
  tags: [],
  msrpDollars: 53.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:43.134Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
